import e from "./index31.js";
import { handleBreakpoints as t } from "./index33.js";
import n from "./index35.js";
import { createUnaryUnit as r, getValue as i } from "./index37.js";
import a from "./index39.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/cssGrid/cssGrid.js
var o = (e) => {
	if (e.gap !== void 0 && e.gap !== null) {
		let n = r(e.theme, "spacing", 8, "gap");
		return t(e, e.gap, (e) => ({ gap: i(n, e) }));
	}
	return null;
};
o.propTypes = process.env.NODE_ENV === "production" ? {} : { gap: e }, o.filterProps = ["gap"];
var s = (e) => {
	if (e.columnGap !== void 0 && e.columnGap !== null) {
		let n = r(e.theme, "spacing", 8, "columnGap");
		return t(e, e.columnGap, (e) => ({ columnGap: i(n, e) }));
	}
	return null;
};
s.propTypes = process.env.NODE_ENV === "production" ? {} : { columnGap: e }, s.filterProps = ["columnGap"];
var c = (e) => {
	if (e.rowGap !== void 0 && e.rowGap !== null) {
		let n = r(e.theme, "spacing", 8, "rowGap");
		return t(e, e.rowGap, (e) => ({ rowGap: i(n, e) }));
	}
	return null;
};
c.propTypes = process.env.NODE_ENV === "production" ? {} : { rowGap: e }, c.filterProps = ["rowGap"], a(o, s, c, n({ prop: "gridColumn" }), n({ prop: "gridRow" }), n({ prop: "gridAutoFlow" }), n({ prop: "gridAutoColumns" }), n({ prop: "gridAutoRows" }), n({ prop: "gridTemplateColumns" }), n({ prop: "gridTemplateRows" }), n({ prop: "gridTemplateAreas" }), n({ prop: "gridArea" }));
//#endregion
export { s as columnGap, o as gap, c as rowGap };

//# sourceMappingURL=index41.js.map